// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button.q-btn.imgBtn[data-v-5189e17b]{margin-left:0!important;margin-right:15px}.container-table[data-v-5189e17b] .q-table__card{-webkit-box-shadow:none;box-shadow:none}.container-table[data-v-5189e17b] .q-card__section--vert{padding:0!important}", ""]);
// Exports
module.exports = exports;
